// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3qfXe","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__289LY","gfeWrapper":"CalendarEvent_gfeWrapper__16Nww"};